import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { API } from 'app/services';
import { Box, Typography, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useAsyncTask } from 'app/utils';

const useStyles = makeStyles(() => ({
  app: {
    width: '100vw',
    marginLeft: 'calc(50% - 50vw)', // 👈 THIS breaks out of parent container
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#f5f5f5',
  },

  container: {
    width: '90%',
    maxWidth: '1300px',
    height: '90vh',
    background: '#fff',
    borderRadius: '8px',
    boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
    overflow: 'hidden',
    position: 'relative',
  },

  loader: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },

  text: {
    textAlign: 'center',
    paddingTop: '2rem',
  },
}));

const Regtank = () => {
  const classes = useStyles();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const [loading, setLoading] = useState(true);
  const [runLoadRequest] = useAsyncTask('loadRegtankRequest');
  const [regtankURL, setRegtankURL] = useState(null);

  useEffect(() => {
    const token = queryParams.get('token');
    if (token) initRegtank(token);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); 
 
  const initRegtank = async (token) => {
    runLoadRequest(async () => {
      try {
        const result = await API.Auth.regtank_transaction({ token });

        if (result?.redirect_url) {
          setRegtankURL(result.redirect_url);
        } else {
          throw new Error('Invalid Regtank response');
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    });
  };

return (
  <Box className={classes.app}>
    {loading && (
      <div className={classes.loader}>
        <CircularProgress />
      </div>
    )}

    <div className={classes.container}>
      {regtankURL && (
        <iframe
          src={regtankURL}
          title="Regtank Onboarding"
          allow="camera; microphone"
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
          }}
        />
      )}

      {!regtankURL && !loading && (
        <Typography className={classes.text}>
          Failed to load Regtank onboarding.
        </Typography>
      )}
    </div>
  </Box>
)
}

export default Regtank;